import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Box, Collapse, LinearProgress, SxProps, Toolbar } from '@mui/material';

import { getIsLoading } from '../../store/LoaderSlice';
import { USER_PERMISSION_INDIVIDUALS } from '../../store/UserSlice';
import { useAppSelector } from '../../hooks';
import { SafeAreaGaps } from '../../helper';
import InvalidRoute from '../Validate/InvalidRoute';
import Header from './components/Header';
import Courses from '../UserPages/Courses';
import ViewCourse from '../UserPages/ViewCourse';
import Schedule from '../UserPages/Schedule';
import CreateNewCoursePage from '../UserPages/Courses/admin/CreateNewCoursePage';
import CourseSubscriptionProcessing from '../Validate/CourseSubscriptionProcessing';
import Footer from './components/Footer';
import CheckPermission from './components/CheckPermission';

const loaderStyles: SxProps = {
  position: 'fixed',
  zIndex: 1,
  width: '100%',
  top: {
    xs: `calc(${SafeAreaGaps.top} + 56px)`,
    sm: `calc(${SafeAreaGaps.top} + 64px)`,
  },
};

const mainContainerStyles: SxProps = {
  flexGrow: 1,
  width: { sm: `100%` },
  // device height - (header height + footer top bg container height)
  minHeight: { xs: `calc(100vh - 154px)`, sm: `calc(100vh - 250px)` },
};

const PortalPage: React.FC = () => {
  const isLoading = useAppSelector(getIsLoading);

  return (
    <>
      {/* Header */}
      <Header />
      <Toolbar />
      {/* Header Loader */}
      <Collapse in={isLoading} sx={loaderStyles}>
        <LinearProgress color="info" />
      </Collapse>
      {/* Routes */}
      <Box component="main" sx={mainContainerStyles}>
        <Routes>
          <Route
            path="/"
            element={
              <Navigate to={`${process.env.PUBLIC_URL}/portal/courses`} />
            }
          />
          <Route path="/courses" element={<Courses />} />
          <Route path="/courses/:id" element={<ViewCourse />} />
          <Route
            path="/courses/new"
            element={
              <CheckPermission
                permission={{
                  adminCourse: [
                    USER_PERMISSION_INDIVIDUALS.ADMIN_COURSE_CREATE,
                  ],
                }}
              >
                <CreateNewCoursePage />
              </CheckPermission>
            }
          />
          <Route
            path="/courses/subscription/processing/:stripeSessionId"
            element={<CourseSubscriptionProcessing />}
          />
          <Route
            path="/schedule"
            element={
              <CheckPermission
                permission={{
                  schedule: [USER_PERMISSION_INDIVIDUALS.SCHEDULE_VIEW],
                  adminSchedule: [
                    USER_PERMISSION_INDIVIDUALS.ADMIN_SCHEDULE_VIEW,
                  ],
                }}
              >
                <Schedule />
              </CheckPermission>
            }
          />
          {/* Validate */}
          <Route path="*" element={<InvalidRoute />} />
        </Routes>
      </Box>
      <div style={{ height: '15px' }} />
      <Box
        sx={{
          background: `url('${process.env.PUBLIC_URL}/images/shapes/wave-with-gadgets.png') bottom left/contain repeat-x`,
          height: { xs: '100px', sm: '186px' },
        }}
      />
      <Footer />
    </>
  );
};

export default PortalPage;
